import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "grid grid-cols-1 mt-4 gap-y-6 sm:grid-cols-2 sm:gap-x-4"
}
const _hoisted_2 = { class: "flex flex-1" }
const _hoisted_3 = { class: "flex flex-col" }

import {onMounted, Ref, ref} from "vue";
import {client, trackEvent} from '@/shared';
import { RadioGroup, RadioGroupDescription, RadioGroupLabel, RadioGroupOption } from '@headlessui/vue';
import { CheckCircleIcon } from '@heroicons/vue/20/solid';
import {
    GetProfileMessaging, GetProfileMessagingResponse,UpdateProfileMessaging
} from "@/dtos";
import NotificationSuccess from "@/main/components/NotificationSuccess.vue";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import SkeletonCard from "@/main/components/skeletons/SkeletonCard.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileMessagingSettings',
  setup(__props) {

// @ts-ignore
onMounted(async () => {
    await getProfileMessagingSettings();
});

const messagingSettingOptions = ref([
    { name: "Yes", description: "Allow other StageAgent members to message you with a request to start an email conversation.",  value: true},
    { name: "No", description: "Do not allow other StageAgent members to message you directly.", value: false}
]);

const isFetching = ref(true);

const isMessagingEnabled = ref("");
const getProfileMessagingSettings = async () => {
    await client.get<GetProfileMessagingResponse>(new GetProfileMessaging())
        .then(response => {
            isMessagingEnabled.value = response.isMessagingEnabled;
            isFetching.value = false;
        });
}

const updateSuccessful: Ref<Boolean> = ref(false);
const responseStatus = ref(null);

const updateProfileMessagingSettings = async () => {
    updateSuccessful.value = false;
    await client.post(new UpdateProfileMessaging({
        enableMessaging : isMessagingEnabled.value
    }))
        .then(() => {
            updateSuccessful.value = true;
            responseStatus.value = null;

            trackEvent( 'profile_updated', {
                method: 'messaging',
                enabled: isMessagingEnabled.value
            });
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ErrorSummary, { "response-status": responseStatus.value }, null, 8, ["response-status"]),
    _createVNode(_unref(RadioGroup), {
      modelValue: isMessagingEnabled.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((isMessagingEnabled).value = $event)),
        _cache[1] || (_cache[1] = _ => updateProfileMessagingSettings())
      ]
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(RadioGroupLabel), { class: "text-lg font-medium text-gray-900" }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("Enable Messaging?")
          ])),
          _: 1
        }),
        (isFetching.value)
          ? (_openBlock(), _createBlock(SkeletonCard, {
              key: 0,
              class: "mt-4",
              "card-style": "long",
              "num-of-cards": 2
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messagingSettingOptions.value, (setting) => {
                return (_openBlock(), _createBlock(_unref(RadioGroupOption), {
                  as: "template",
                  key: setting.value,
                  value: setting.value
                }, {
                  default: _withCtx(({ checked, active }) => [
                    _createElementVNode("div", {
                      class: _normalizeClass([checked ? 'border-transparent' : 'border-clay-500', active ? 'ring-2 ring-clay-500 bg-clay-50' : '', 'relative flex cursor-pointer rounded-lg border  p-4 shadow-sm focus:outline-hidden'])
                    }, [
                      _createElementVNode("span", _hoisted_2, [
                        _createElementVNode("span", _hoisted_3, [
                          _createVNode(_unref(RadioGroupLabel), {
                            as: "span",
                            class: "block text-sm font-medium text-gray-900"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(setting.name), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_unref(RadioGroupDescription), {
                            as: "span",
                            class: "flex items-center mt-1 text-sm text-clay-800"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(setting.description), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ]),
                      checked
                        ? (_openBlock(), _createBlock(_unref(CheckCircleIcon), {
                            key: 0,
                            class: "w-5 h-5 text-clay-600",
                            "aria-hidden": "true"
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", {
                        class: _normalizeClass([active ? 'border' : 'border-2', checked ? 'border-clay-500' : 'border-transparent', 'pointer-events-none absolute -inset-px rounded-lg']),
                        "aria-hidden": "true"
                      }, null, 2)
                    ], 2)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(NotificationSuccess, {
      show: updateSuccessful.value,
      content: "Your changes were successfully saved.",
      title: "Successfully saved!"
    }, null, 8, ["show"])
  ], 64))
}
}

})